<template>
  <router-link :to="_to">
    <div
      class="nav-drawer-list-item"
      :class="{activiated:activiated,subActive: subActive,disabled:isDisabled}"
      @click="$_onClick()"
    >
      <i
        v-if="!activiated"
        class="leading-icon"
        :class="listItem.leadingIcon"
      />
      <i
        v-if="activiated"
        class="leading-icon"
        :class="listItem.activiatedLeadingIcon"
      />
      <p class="text-label">
        {{ $t(listItem.textLabel) }}
      </p>
      <div
        v-if="listItem.trailingBadge"
        class="trailing-badge"
      >
        {{ this.$_itemTrailingBadgeByTrailingBadge(listItem.trailingBadge) }}
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "NavDrawerListItem",
  props: {
    listItem: {
      type: Object,
      default() {
        return {};
      },
    },
    subActive: {
      type: Boolean,
      default: false,
    },
    activiated: {
      type: Boolean,
      default: false,
    },
    to: {
      type: String,
      default: "",
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    _to() {
      return this.isDisabled ? "" : this.to;
    },
  },
  methods: {
    $_onClick() {
      this.$emit("click");
    },
    $_itemTrailingBadgeByTrailingBadge(trailingBadge) {
      if (trailingBadge > 100) return 99 + "+";
      return trailingBadge;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/nav-drawer-list-item";
</style>